module.exports = {
  'en': {
    'HRPM81X1': {
      '10': 'Emp. ID',
      '20': 'Or Department',
      '30': 'Condition',
      '40': 'Report Type',
      '50': 'Abstract',
      '60': 'Full',
      '70': 'Emp. Code',
      '80': 'Employee Name',
      '90': 'Department',
      '100': 'Position',
      '110': 'Level',
      '120': 'Begin Date'
    },
    'HRPM81X2': {
      '10': 'Employee Code',
      '15': 'Employment Data',
      '20': 'Department',
      '30': 'Position',
      '40': 'Level',
      '50': 'Job Description',
      '60': 'Type of Employment',
      '70': 'Type of Employee',
      '80': 'Payroll Group',
      '84': 'Job Grade',
      '87': 'Group GL',
      '90': 'Salary',
      '100': 'Begin Date',
      '110': 'Service Year',
      '120': 'Year',
      '130': 'Month',
      '140': 'Age',
      '150': 'Year',
      '160': 'Month',
      '170': 'Yrs in Level',
      '180': 'Year',
      '190': 'Month',
      '200': 'Yrs in Position',
      '210': 'Year',
      '220': 'Month',
      '230': 'Education Level',
      '240': 'Institute',
      '250': 'Major',
      '260': 'Branch'
    },
    'HRPM81X3': {
      '10': 'Work Experience',
      '20': 'Seq',
      '30': 'Company Name',
      '40': 'Positon',
      '50': 'Begin Date',
      '60': 'End Date'
    },
    'HRPM81X4': {
      '10': 'History of Salary Increase',
      '20': 'History of Salary Increase',
      '30': 'Effective Date',
      '40': 'Old Salary',
      '50': 'New Salary',
      '60': 'History of performance appraisal',
      '70': 'Year',
      '80': 'Grade'
    },
    'HRPM81X5': {
      '10': 'History of Punishment',
      '20': 'Punishment',
      '30': 'Punishment Period',
      '40': 'Details Of Mistake'
    },
    'HRPM81X6': {
      '10': 'Others Data',
      '20': 'Personal Data',
      '30': 'History Data',
      '40': 'Work Data'
    }
  },
  'th': {
    'HRPM81X1': {
      '10': 'รหัสพนักงาน',
      '20': 'หรือหน่วยงาน',
      '30': 'เงื่อนไขการค้นหาข้อมูล',
      '40': 'รูปแบบรายงานที่ต้องการ',
      '50': 'แบบย่อ',
      '60': 'แบบสมบูรณ์',
      '70': 'รหัสพนักงาน',
      '80': 'ชื่อ-นามสกุล',
      '90': 'หน่วยงาน',
      '100': 'ตำแหน่ง',
      '110': 'ระดับ',
      '120': 'วันที่เข้างาน'
    },
    'HRPM81X2': {
      '10': 'รหัสพนักงาน',
      '15': 'ข้อมูลการจ้างงาน',
      '20': 'หน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'ระดับ',
      '50': 'ลักษณะงาน',
      '60': 'ประเภทการจ้างงาน',
      '70': 'ประเภทพนักงาน',
      '80': 'กลุ่มการจ่ายเงินเดือน',
      '84': 'Job Grade',
      '87': 'กลุ่ม GL',
      '90': 'เงินเดือน',
      '100': 'วันที่เข้างาน',
      '110': 'อายุงาน',
      '120': 'ปี',
      '130': 'เดือน',
      '140': 'อายุ',
      '150': 'ปี',
      '160': 'เดือน',
      '170': 'อายุระดับ',
      '180': 'ปี',
      '190': 'เดือน',
      '200': 'อายุตำแหน่ง',
      '210': 'ปี',
      '220': 'เดือน',
      '230': 'ระดับการศึกษา',
      '240': 'สถาบัน',
      '250': 'สาขาการศึกษา',
      '260': 'สาขาวิชา'
    },
    'HRPM81X3': {
      '10': 'ประสบการณ์การทำงาน',
      '20': 'ลำดับที่',
      '30': 'ชื่อบริษัท',
      '40': 'ตำแหน่ง',
      '50': 'วันที่เข้างาน',
      '60': 'วันที่ออก'
    },
    'HRPM81X4': {
      '10': 'ประวัติการเพิ่มเงินเดือน',
      '20': 'ประวัติการเพิ่มเงินเดือน',
      '30': 'วันที่มีผลบังคับใช้',
      '40': 'เงินเดือนเดิม',
      '50': 'เงินเดือนที่ปรับ',
      '60': 'การประเมิน',
      '70': 'ปี',
      '80': 'เกรด'
    },
    'HRPM81X5': {
      '10': 'ประวัติการลงโทษ',
      '20': 'การลงโทษ',
      '30': 'ช่วงวันที่ลงโทษ',
      '40': 'รายละเอียดการกระทำผิด'
    },
    'HRPM81X6': {
      '10': 'รายละเอียดอื่น',
      '20': 'ข้อมูลส่วนตัว',
      '30': 'ประวัติส่วนตัว',
      '40': 'ข้อมูลการมาทำงาน'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms13x.js